module.exports = __webpack_public_path__ + "static/media/audio_dart.352e856b.svg";